import api from '~/services/api';

function getUserPlans() {
  return api.request({
    url: '/billing/current-features/',
  });
}

function getPricingPlans() {
  return api.request({
    url: '/billing/plans',
  });
}

function setUserPlan(planName) {
  return api.request({
    url: '/billing/plan-upgrade',
    method: 'POST',
    data: {
      plan: planName,
    },
  });
}

export { getUserPlans, setUserPlan, getPricingPlans };
